import { Component, OnInit } from '@angular/core';
import { BlogService } from '../services/blog.service';
import { BlogList } from '../blog-interface';
import { DataService } from '../../services/data.service';
import { environment } from '../../../environments/environment.prod';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ByEmployee } from '../../skill-matrix/api-interfaces';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SkillService } from '../../skill-matrix/services/skill.service';
import { FlashService } from '../../flash/flash.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-list-blog',
  templateUrl: './list-blog.component.html',
  styleUrls: ['./list-blog.component.css']
})
export class ListBlogComponent implements OnInit {
  employeeDetail: Observable<ByEmployee>
  blogList: BlogList[];
  filterForm: FormGroup;
  currentPageNo = 1;
  submission_date;
  start_date;
  end_date;
  limit;
  employee_id = '';
  sortBy = '';
  orderBy = '';
  type = '';
  total;
  perpage;
  date;
  default = [
    {
      'value': 'Yearly',
      'key': 'Yearly',
      'start_date': '2020-04-01',
      'end_date': '2021-03-30'
    }
  ]
  types = [
    {
      'value': 'all',
      'label': 'All'
    },
    {
      'value': 'submission_date',
      'label': 'Submission Date'
    },
    {
      'value': 'published_date',
      'label': 'Published Date'
    }
  ]
  times = environment.Quarters;
  employee: Observable<ByEmployee>;
  todayDate;
  startYear;
  endYear;
  sDate;
  eDate;
  date1;
  date2;
  noData: boolean;

  constructor(
    public blogService: BlogService,
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private skillService: SkillService,
    public flashService: FlashService
  ) {
    this.todayDate = new Date();
    const presentDate = this.stringToDate(this.todayDate);
    if (presentDate.date.month >= 4) {
      this.startYear = presentDate.date.year;
      this.endYear = presentDate.date.year + 1;
    }
    else {
      this.startYear = presentDate.date.year - 1;
      this.endYear = presentDate.date.year;
    }
    this.employeeDetail = this.skillService.getEmployee();
    this.filterForm = this.formBuilder.group({
      quarter: new FormControl('Yearly', Validators.required),
      type: new FormControl('all', Validators.required),
      employee: new FormControl('', Validators.required)
    });
  }
  ngOnInit() {
    this.getBlogList();
  }
  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: (value.getMonth() + 1),
        day: (value.getDate())
      }
    };
    return dateObject;
  }
  dateToString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }
  changeTime(value) {
    this.default.forEach(data => {
      if (value == data.value) {
        this.date1 = data.start_date;
        this.date2 = data.end_date;
      }
    })
    this.times.forEach(data => {
      if (value == data.key) {
        this.date1 = data.start_date;
        this.date2 = data.end_date;
      }
    })
    this.start_date = this.stringToDate(new Date(this.date1))
    this.end_date = this.stringToDate(new Date(this.date2))
    if (value === "Yearly") {
      this.start_date.date.year = this.startYear;
      this.end_date.date.year = this.endYear;
    } else if ((this.start_date && this.start_date.date.month >= 4) && (this.end_date && this.end_date.date.month >= 4)) {
      this.start_date.date.year = this.startYear;
      this.end_date.date.year = this.startYear;
    } else {
      this.start_date.date.year = this.endYear;
      this.end_date.date.year = this.endYear;
    }
    this.start_date = this.dateToString(this.start_date);
    this.end_date = this.dateToString(this.end_date)
  }
  changeType(value) {
    if (value === 'submission_date') {
      this.type = value;
    }
    else {
      this.type = value;
    }
  }
  changeEmployee(value) {
    this.employee_id = value;
  }
  goToUrl(url) {
    if (url != "") {
      window.open(url);
    }
    else {
      this.flashService.show('Please update blog url for further action', 'alert-danger')
    }
  }
  onSubmit(formData) {
    this.changeTime(formData.value.quarter);
    this.getBlogList();
  }
  getBlogList(pgNo?) {
    this.spinnerService.show();
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.limit = 15;
    this.blogService.getBlogList(this.start_date, this.end_date, this.type, this.currentPageNo,
      this.limit, this.employee_id, this.orderBy, this.sortBy).subscribe(data => {
        this.total = data['totalcount'];
        this.perpage = data['perpage'];
        this.blogList = data['blog_list'];
        if (this.blogList.length == 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        this.spinnerService.hide();
      })
  }
  goToEdit(id, blog) {
    this.blogService.editData = blog;
    this.router.navigate(['/blog/edit/', id]);
  }
  deleteBlog(id, blogs, i) {
    this.spinnerService.show();
    this.blogService.deleteBlog(id).subscribe(data => {
      blogs.splice(i, 1);
      this.spinnerService.hide();
    })
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/blog/list-blog/list-blog.component.ts